import { ApolloError, useMutation } from "@apollo/client";
import { UnpauseHoldInput } from "@clockwise/schema";
import { UnpauseHoldDocument } from "@clockwise/web-commons/src/mutations/__generated__/UnpauseHold.generated";
import { UNPAUSE_ON_SUCCESS_MSG } from "@clockwise/web-commons/src/ui/smart-hold-state/SmartHoldState";
import { useCallback } from "react";
import toast from "react-hot-toast";

type UseUnpauseHoldProps = {
  input: UnpauseHoldInput;
  calendarId: string;
  onError?: (error: ApolloError) => void;
};

type UseUnpauseHoldResult = [
  () => Promise<void>,
  { loading: boolean; error: ApolloError | undefined },
];

export function useUnpauseHold({
  input,
  calendarId,
  onError,
}: UseUnpauseHoldProps): UseUnpauseHoldResult {
  const [unpauseHold, { loading, error }] = useMutation(UnpauseHoldDocument, {
    variables: { input, calendarId },
    onError,
  });

  const onUnpauseHold = useCallback(async () => {
    const result = await unpauseHold();
    if (result.data?.unpauseHold?.success) {
      toast.success(UNPAUSE_ON_SUCCESS_MSG);
    }
  }, [unpauseHold]);

  return [onUnpauseHold, { loading, error }];
}
